
import React, { Fragment, useState, useEffect, useContext } from "react";
import { getProductByCategory } from "../dashboardUser/FetchApi";
import { useHistory } from "react-router-dom";
const apiURL = process.env.REACT_APP_API_URL;
const ProductContainer = ({ category }) => {
    const [products, setProducts] = useState([{ pName: "Loading", pImages: ["loading"] }])
    const [loading,setLoading] = useState(true);
    useEffect(() => {
        if (category) {
            getProductByCategory(category).then(result => {
                setProducts([])
                setProducts(result)
                console.log(result)
                setLoading(false)
            })
        }
    }, [])
    const history = useHistory();

    return (
        <div className='featured-products'>
            {products.length>0 ? products.map(product => (
                // <div className='product-container border-solid border-2'>
                //     <div className='featured-img h-40 w-40'>
                //         <img src={`${apiURL}/api/photo/get-photo/${product.pImages[0]}`} alt="featured-product-img" />
                //     </div>
                //     <div className='featured-text text-center'>
                //         <h6>{product.pName}</h6>
                //     </div>
                // </div>
                <Fragment key={product._id}>
                    <div className="products-server drop-shadow-2xl">
                        <div className="relative m-1 border-1 bg-origin-content bg-gray-100 h-52 w-40 md:w-56 rounded-lg">
                            <img
                                onClick={(e) => history.push(`/products/${product._id}`)}
                                className="w-full h-40 w-36 object-scale-down object-center cursor-pointer p-2"
                                src={`${apiURL}/api/photo/get-photo/${product.pImages[0]}`}
                                alt=""
                            />
                            <div className="flex items-center justify-center mt-2">
                                <div className="text-gray-600 font-light truncate mx-2">
                                    {product.pName}
                                </div>
                            </div>
                            <div className="text-center">₹{product.pPrice}</div>
                        </div>
                    </div>
                </Fragment>
            )) : <div className="m-4">No Products in this Category</div>}
        </div>
    )
}

export default ProductContainer